import { Table } from 'components/Table'
import { useSort } from 'components/Table/Sort'
import { REPORT_SORT_FIELDS } from 'features/yieldbirdWrapperAgent/api/types'
import { useReports } from 'features/yieldbirdWrapperAgent/hooks/useReports'
import { toListReportsPaging } from 'features/yieldbirdWrapperAgent/utils/toListReportsPaging'
import { DEFAULT_SORT } from './constants'
import { useColumns } from './useColumns'

import type { FilterValue } from 'components/Filter'
import type { PaginationProps } from 'components/Table/Pagination'
import type { UsePagination } from 'components/Table/Pagination/types'
import type { Report, ReportSortField } from 'features/yieldbirdWrapperAgent/api/types'

type Props = {
  filters: FilterValue[]
  pagination: UsePagination
}

export const ReportsTable = ({ filters, pagination }: Props): React.JSX.Element => {
  const columns = useColumns()
  const { page, rowsPerPage } = pagination
  const { props: sortProps, sort } = useSort<Report, ReportSortField>(DEFAULT_SORT, [
    ...REPORT_SORT_FIELDS,
  ])

  const { count, loading, reports } = useReports({
    ...toListReportsPaging({ page, rowsPerPage }),
    sortBy: sort.by,
    sortDirection: sort.direction,
    url: filters[0],
  })

  const paginationProps: PaginationProps = {
    count,
    ...pagination,
  }

  return (
    <Table<Report>
      columns={columns}
      data={reports}
      loading={loading}
      pagination={paginationProps}
      sort={sortProps}
    />
  )
}
